import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=c63fe644&scoped=true&"
import script from "./js/searchPage.js?vue&type=script&lang=js&"
export * from "./js/searchPage.js?vue&type=script&lang=js&"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=c63fe644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63fe644",
  null
  
)

export default component.exports